import { Api } from 'models/services/api';
import { CreateOpenaiAccountQuery } from 'models/services/graphql';

import { OpenaiAccountData, OpenaiAccountDataToSave } from '../index';

type DataToCreate = {
  input: OpenaiAccountDataToSave;
};

const RequestQuery = `
  mutation CreateOpenaiAccount($input: CreateOpenaiAccountInput!) {
    ${CreateOpenaiAccountQuery}
  }
`;

type ResponseData = {
  data: {
    createOpenaiAccount: OpenaiAccountData
  }
}

class CreateGql {

  readonly api: Api<ResponseData>;
  readonly document?: OpenaiAccountData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToCreate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.createOpenaiAccount;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { CreateGql };